import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LoginService } from '../services/login.service';
import { StorageService } from '../services/storage.service';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: "root"
})
export class PermissaoGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private location: Location,
    private storageService: StorageService,
    private translate: TranslateService) {
  }

  VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO: string = 'Você não tem permissão para acessar este recurso!';
  ACESSO_NEGADO: string = 'Acesso negado!';

    canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Verifica se o usuário está autenticado
    if (!this.loginService.usuarioEstaAutenticado()) {
      this.router.navigate(['/login']);
      return false;
    }

    const usuario = this.storageService.getUsuario();
    if (!usuario) {
      this.router.navigate(['/login']);
      return false;
    }

    const permissoesNecessarias = route.data['permissoes'];
    console.debug('permissoesNecessarias', permissoesNecessarias);

    if (!permissoesNecessarias) {
      console.warn('PermissaoGuard: Nenhuma permissão especificada na rota');
      return true;
    }

    var temPermissao = false;
    permissoesNecessarias.forEach(permissaoNecessaria => {
      if(!temPermissao)
        temPermissao = usuario.PermissaoUsuario && usuario.PermissaoUsuario[permissaoNecessaria];
    })

    if (temPermissao) {
      return true;
    }

    this.VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO = this.translate.instant('VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO');
    this.ACESSO_NEGADO = this.translate.instant('ACESSO_NEGADO');

    Swal.fire(this.ACESSO_NEGADO, this.VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO, 'warning');

    this.location.back();

    return false;
  }
}
